import moment from 'moment';

export default (startDate, days) => {
  const start = moment(startDate);
  const end = moment(startDate).add(days - 1, 'days');

  return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
};



// WEBPACK FOOTER //
// ./src/golf-schools/formatClassDateRange.js